<template>
    <div class="entry-grid">
        <!-- 全国楼凤 -->
        <router-link to="/" class="entry-card" exact>
            <div class="entry-text">
                <div class="entry-title orange">全国楼凤</div>
                <div class="entry-subtitle">千万狼友验证分享</div>
            </div>
            <div class="entry-icon-wrap">
                <img class="entry-icon-img" :src="quanguoLogo" alt="全国楼凤" />
            </div>
        </router-link>

        <!-- 包养专区 -->
        <router-link to="/maintenance" class="entry-card">
            <div class="entry-text">
                <div class="entry-title green">包养专区</div>
                <div class="entry-subtitle">视频认证 伴游包养</div>
            </div>
            <div class="entry-icon-wrap">
                <img class="entry-icon-img" :src="baoyLogo" alt="包养专区" />
            </div>
        </router-link>

        <!-- 各地mm群 -->
        <router-link to="/regionalGroups" class="entry-card">
            <div class="entry-text">
                <div class="entry-title blue">各地mm群</div>
                <div class="entry-subtitle">想约的妹 群里都有</div>
            </div>
            <div class="entry-icon-wrap">
                <img class="entry-icon-img" :src="yanqunLogo" alt="各地mm群" />
            </div>
        </router-link>

        <!-- 暗巷 -->
        <router-link to="/backAlley" class="entry-card">
            <div class="entry-text">
                <div class="entry-title orange">暗巷</div>
                <div class="entry-subtitle">性价比的享受</div>
            </div>
            <div class="entry-icon-wrap">
                <img class="entry-icon-img" :src="anxianglogo" alt="暗巷" />
            </div>
        </router-link>
    </div>
</template>

<script>
    import quanguoLogo from "@/assets/quanguo.png"
    import baoyLogo from "@/assets/baoy.png"
    import yanqunLogo from "@/assets/yanqun.png"
    import anxianglogo from "@/assets/anxiang.png"

    export default {
        name: "ZhaiTwoButtons",
        data() {
            return {
                quanguoLogo,
                baoyLogo,
                yanqunLogo,
                anxianglogo
            }
        }
    }
</script>

<style scoped>
    .entry-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        background: #f3f3f3;
        border-top: 1px solid #e5e5e5;
        border-left: 1px solid #e5e5e5;
        width: 100%;
    }

    .entry-card {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 120px;
        padding: 18px 14px;
        background: #fff;
        border-right: 1px solid #e5e5e5;
        border-bottom: 1px solid #e5e5e5;
        text-decoration: none;
        box-sizing: border-box;
        transition: all 0.25s ease;
    }

    .entry-text {
        flex: 1;
        min-width: 0;
    }

    .entry-title {
        font-size: 22px;
        line-height: 1.2;
        font-weight: 500;
        margin-bottom: 10px;
        transition: all 0.25s ease;
    }

    .entry-subtitle {
        font-size: 15px;
        color: #9e9e9e;
        line-height: 1.4;
        word-break: break-all;
        transition: all 0.25s ease;
    }

    .orange {
        color: #ff7f45;
    }

    .green {
        color: #88c84f;
    }

    .blue {
        color: #36a9e1;
    }

    .entry-icon-wrap {
        width: 78px;
        height: 78px;
        margin-left: 14px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .entry-icon-img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        display: block;
        transition: all 0.25s ease;
    }

    /* hover 效果 */
    .entry-card:hover {
        background: #fafafa;
    }

    .entry-card.router-link-active,
    .entry-card.router-link-exact-active {
        background: #fff7f2;
    }

    .entry-card.router-link-active .entry-subtitle,
    .entry-card.router-link-exact-active .entry-subtitle {
        color: #666;
    }

    .entry-card.router-link-active .entry-icon-img,
    .entry-card.router-link-exact-active .entry-icon-img {
        transform: scale(1.05);
    }


    @media (max-width: 768px) {
        .entry-card {
            min-height: 105px;
            padding: 14px 10px;
        }

        .entry-title {
            font-size: 18px;
            margin-bottom: 8px;
        }

        .entry-subtitle {
            font-size: 13px;
        }

        .entry-icon-wrap {
            width: 62px;
            height: 62px;
            margin-left: 10px;
        }
    }
</style>
